<script lang="ts">
	import PageView from '../../../components/PageView.svelte'
	import Text from '../../../components/Text.svelte'
</script>

<PageView title="Settings" center backTo={{ name: 'Home', state: 'app.home.overview' }}>
	<Text content="We're working on it!" />
</PageView>
